define('SuiteCommerce.OrderStatus.OrderFinder.SearchForm.View',
  [
    'SuiteCommerce.OrderStatus.OrderFinder.Help.View',
    'SuiteCommerce.OrderStatus.Common.DependencyProvider',
    'suitecommerce_orderstatus_search_form.tpl',
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone',
    'Backbone.FormView',
    'Backbone.CompositeView',
    'underscore',
    'SuiteCommerce.OrderStatus.Instrumentation.InstrumentationHelper'
  ],
  function define(
    HelpView,
    DependencyProvider,
    Template,
    Utils,
    Backbone,
    BackboneFormView,
    BackboneCompositeView,
    _,
    InstrumentationHelper
  ) {
    'use strict';
    return Backbone.View.extend({
      template: Template,
      events: {},
      bindings: {},
      childViews: {
        'GlobalMessage.Feedback': function registerGlobalMessageFeedbackDataView() {
          return new DependencyProvider.MessageView({
            message: this.state.message,
            type: this.state.messageType,
            closable: true
          });
        }
      },
      initialize: function initialize(options) {
        var landingPageLoadedLog;
        this.title = Utils.getConfigurationParameter('pageTitle');
        this.ERRORS = {
          ORDER_NOT_FOUND: Utils.getConfigurationParameter('orderNotFoundMessage')
        };
        this.model = options.model;
        this.setupOrderFinderForm();
        this.state = {
          code: '',
          message: '',
          messageType: ''
        };
        BackboneFormView.add(this);
        landingPageLoadedLog = InstrumentationHelper.getLog('landingPageLoadedLog');
        landingPageLoadedLog.setParametersToSubmit({
          componentArea: 'SC Order Status',
          activity: 'Order status landing page was opened'
        });
        landingPageLoadedLog.submit();
      },
      getBreadcrumbPages: function getBreadcrumbPages() {
        return [{
          text: this.title,
          href: '/' + Utils.getConfigurationParameter('route')
        }];
      },
      setupOrderFinderForm: function setupOrderFinderForm() {
        this.setupBindingsForOrderFinderForm();
        this.setupValidationRulesForOrderFinderForm();
        this.registerEventsRelatedToOrderFinderForm();
      },
      setupBindingsForOrderFinderForm: function setupBindingsForOrderFinderForm() {
        var self = this;
        var formControls = this.getFormControls();
        _.each(formControls.fields, function bindField(field) {
          self.addBindingForProperty('name', field.name, field.bindingProperty);
        });
      },
      addBindingForProperty: function addBindingForProperty(attribute, value, property) {
        this.bindings['[' + attribute + '="' + value + '"]'] = property;
      },
      setupValidationRulesForOrderFinderForm: function setupValidationRulesForOrderFinderForm() {
        var self = this;
        var formControls = this.getFormControls();
        _.each(formControls.fields, function addValidationRuleForField(field) {
          self.model.addValidationRuleForProperty(
            field.name, {
              required: true,
              msg: Utils.getConfigurationParameter('requiredFieldMessage').replace(
                '{{field}}',
                field.label
              )
            }
          );
        });
      },
      registerEventsRelatedToOrderFinderForm: function registerEventsRelatedToOrderFinderForm() {
        this.events['submit form'] = 'submitOrderFinderForm';
        this.events['click [data-action="showHelp"]'] = 'openHelpView';
      },
      submitOrderFinderForm: function submitOrderFinderForm(submitEvent) {
        var promise;
        var self = this;
        var errorCode;
        var searchSalesOrderRequestLog = InstrumentationHelper.getLog('searchSalesOrderRequestLog');
        submitEvent.preventDefault();
        promise = this.saveForm(submitEvent);
        if (promise) {
          searchSalesOrderRequestLog.startTimer();
          this.setSubmitedValues();
          promise.then(
            function successActions() {
              self.state.code = '';
              self.state.message = '';
              self.state.messageType = '';
              searchSalesOrderRequestLog.endTimer();
              searchSalesOrderRequestLog.setParametersToSubmit({
                componentArea: 'SC Order Status',
                activity: 'Time it takes to search a sales order',
                totalTime: searchSalesOrderRequestLog.getElapsedTimeForTimer()
              });
              searchSalesOrderRequestLog.submit();
            },
            function failActions(response) {
              response.preventDefault = true;
              errorCode = response.responseJSON.name;
              if (self.ERRORS[errorCode]) {
                self.state.code = errorCode;
                self.state.message = self.ERRORS[errorCode];
              } else {
                if (response.responseJSON.message) {
                  self.state.message = response.responseJSON.message;
                } else {
                  self.state.message = response.responseJSON.name + ': ' + response.responseJSON.stack[0];
                }
                self.state.code = response.responseJSON.name;
              }
              self.state.messageType = 'error';
            }
          ).always(_.bind(self.render, self));
        }
      },
      setSubmitedValues: function setSubmitedValues() {
        var submittedOrderNumber = this.validationModel.get('ordernumber');
        var submittedVerificationfield = this.validationModel.get('verificationfield');
        this.model.set('ordernumber', submittedOrderNumber);
        this.model.set('verificationfield', submittedVerificationfield);
      },
      getFormControls: function getFormControls() {
        var formControls = {};
        formControls.fields = [];
        formControls.fields.push({
          name: 'ordernumber',
          bindingProperty: 'ordernumber',
          label: Utils.getConfigurationParameter('orderNumberLabel'),
          value: this.model.get('ordernumber'),
          placeholder: Utils.getConfigurationParameter('orderNumberHelp'),
          tabindex: 1
        });
        formControls.fields.push({
          name: 'verificationfield',
          bindingProperty: 'verificationfield',
          label: Utils.getConfigurationParameter('verificationFieldLabel'),
          value: this.model.get('verificationfield'),
          placeholder: Utils.getConfigurationParameter('verificationFieldHelp'),
          tabindex: 2
        });
        formControls.buttons = {};
        formControls.buttons.submit = {
          label: Utils.getConfigurationParameter('submitButtonLabel'),
          tabindex: 3,
          alt: Utils.getConfigurationParameter('submitButtonHelp')
        };
        return formControls;
      },
      openHelpView: function openHelpView() {
        var helpView = new HelpView();
        this.options.application.getLayout().showInModal(helpView);
      },
      getContext: function getContext() {
        return {
          title: this.title,
          viewElements: {
            description: {
              label: Utils.getConfigurationParameter('pageDescription'),
              show: !!(Utils.getConfigurationParameter('pageDescription'))
            },
            helpLink: {
              label: Utils.getConfigurationParameter('helpLink'),
              show: !!(Utils.getConfigurationParameter('helpLink'))
            },
            loginSectionText: {
              label: Utils.getConfigurationParameter('orderLoginSectionText'),
              show: !!(Utils.getConfigurationParameter('orderLoginSectionText'))
            },
            loginSectionLink: {
              label: Utils.getConfigurationParameter('loginSectionLink'),
              show: !!(Utils.getConfigurationParameter('loginSectionLink'))
            }
          },
          formControls: this.getFormControls(),
          order: this.model,
          isFeedback: !!this.state.code
        };
      }
    });
  });
